import { render, staticRenderFns } from "./MdAffiliateList.vue?vue&type=template&id=68c1f994&scoped=true&"
import script from "./MdAffiliateList.vue?vue&type=script&lang=js&"
export * from "./MdAffiliateList.vue?vue&type=script&lang=js&"
import style0 from "./MdAffiliateList.vue?vue&type=style&index=0&id=68c1f994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1f994",
  null
  
)

export default component.exports